export default class CreateMarkerCommentModel {
    markerId = "";
    comment = "";
    createdBy = "";
    createdByUserId = "";

    constructor(markerId, comment, createdBy, userId){
        this.markerId = markerId;
        this.comment = comment;
        this.createdBy = createdBy;
        this.createdByUserId = userId;
    }
}